<div id="item-container" >
	<div fxLayout="column">
		<span class="middle">{{item}}</span>
		<small class="middle">{{item2}}</small>

	</div>
<mat-icon svgIcon="open-with" class="last" mat-list-icon></mat-icon>
</div>